export const __TOKEN_KEY__ = "__TOKEN_KEY__";

/**
 * 获取授权凭证
 */
export function getAuthorization() {
  return `Bearer ${window.sessionStorage.__TOKEN_KEY__}`;
}
